import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const text = this.textValue
    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      const originalTitle = this.element.getAttribute("title")
      this.element.setAttribute("title", "¡Copiado!")
      setTimeout(() => {
        if (originalTitle) {
          this.element.setAttribute("title", originalTitle)
        } else {
          this.element.removeAttribute("title")
        }
      }, 1500)
    })
  }
}
